import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useRecoilState, useRecoilValue } from "recoil";
import { getRecoil, resetRecoil, setRecoil } from "recoil-nexus";
import ConciergeRequestModal from "../../components/modal/ConciergeRequestModal";
import ConfirmModal from "../../components/modal/ConfirmModal";
import CustomerServiceChatModal from "../../components/modal/CustomerServiceChatModal";
import SelectChatModal from "../../components/modal/SelectChatModal";
import StoreChatModal from "../../components/modal/StoreChatModal";
import ApiController from "../../controller/ApiController";
import { ChatDetailType } from "../../controller/DirectMessageController";
import LogController from "../../controller/LogController";
import { useToast } from "../../controller/ToastController";

import { authState } from "../../recoil/auth";
import {
  chatOrderType,
  chatType,
  csChatFinishedState,
  csChatListState,
  csChatState,
  newChatListState,
  selectChatState,
  storeChatFinishedState,
  storeChatState,
} from "../../recoil/chat";
import { LANG_JP, LANG_KO, langState, langText } from "../../recoil/lang";
import { conciergeState, ConciergeStateType } from "../../recoil/socket";
import { useQueryClient } from "@tanstack/react-query";
import { areaType } from "../../recoil/area";

let chatTimer: any;
let ExpiredChatTimer: any;

const ChatContent = () => {
  const showToast = useToast();
  const lang = useRecoilValue<number>(langState);

  // 현재 디바이스 방 설정
  const queryClient = useQueryClient();
  const deviceArea = queryClient.getQueryData<areaType | undefined>([
    "device-area",
  ]);

  const [visibleSelectChat, setVisibleSelectChat] =
    useRecoilState<boolean>(selectChatState);

  const conciergeFlag = useRecoilValue<ConciergeStateType>(conciergeState);
  const [visibleConciergeRequest, setVisibleConciergeRequest] =
    useState<boolean>(false);
  const [conciergeRequestData, setConciergeRequestData] = useState<any>([]);

  const [csChatFlag, setCsChatFlag] = useRecoilState<chatType>(csChatState);
  const [csChatDetail, setCsChatDetail] = useState<ChatDetailType[]>([]);

  const [storeChatFlag, setStoreChatFlag] =
    useRecoilState<chatType>(storeChatState);
  const [storeChatDetail, setStoreChatDetail] = useState<ChatDetailType[]>([]);

  const csChatFinishedFlag = useRecoilValue<boolean>(csChatFinishedState);
  const storeChatFinishedFlag = useRecoilValue<boolean>(storeChatFinishedState);

  const [visibleChatConfirm, setVisibleChatConfirm] = useState<{
    visible: boolean;
    title: string;
    target: string;
    onEffect: boolean;
  }>({ visible: false, title: "", target: "", onEffect: false });

  const chatAudio = new Audio(
    `${process.env.PUBLIC_URL}/knockknock/audio/testBell.mp3`
  );

  const closeChatConfirm = () => {
    setVisibleChatConfirm({
      visible: false,
      title: "",
      target: "",
      onEffect: false,
    });
  };

  const openConciergeRequestModal = async () => {
    if (conciergeFlag.concierge_id !== null) {
      const data: any = {
        concierge_id: conciergeFlag.concierge_id,
        accessor: "CLIENT",
        lang: lang,
      };
      try {
        const oRes = await ApiController.concierge.getConciergeRequestDetail(
          data
        );

        if (oRes && oRes.data.ok) {
          setConciergeRequestData(oRes.data.data);
          if (!visibleConciergeRequest || conciergeFlag.isChat) {
            closeChatConfirm();
            setVisibleConciergeRequest(true);
          }
        }
      } catch (e) {
        console.log("err =>", e);
      }
    }
  };

  const openChatRoom = (isOrder: boolean, order?: chatOrderType) => {
    if (isOrder) {
      createChatRoom(true, order);
    } else {
      createChatRoom(false);
    }
  };

  const getChats = async (isOrder: boolean, csId?: number) => {
    try {
      const oParams = {
        cs_id: csId ? csId : isOrder ? storeChatFlag.chat_id : csChatFlag.cs_id,
        lang: lang,
        reader_type: "ROOM",
      };
      const oResponse = await ApiController.chat.getChats(oParams);

      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data) {
          if (isOrder) {
            setStoreChatDetail([...oRes.data.chats]);
            if (!storeChatFlag.visible) {
              setStoreChatFlag((prev) => ({
                ...prev,
                visible: true,
              }));
            }
            setRecoil(newChatListState, (prev) => [
              ...prev.filter((item) => !(item.cs_id === storeChatFlag.chat_id)),
            ]);
          } else {
            setCsChatDetail([...oRes.data.chats]);
            if (!csChatFlag.visible) {
              setCsChatFlag((prev) => ({
                ...prev,
                visible: true,
              }));
            }
            setRecoil(csChatListState, false);
          }
        }
      }
    } catch (e) {
      console.error("err => ", e);
    }
  };

  const createChatRoom = async (isOrder: boolean, order?: chatOrderType) => {
    try {
      if (deviceArea) {
        if (isOrder) {
          if (order) {
            const oParams = {
              contact_person_type: "STORE",
              contact_person: order.store_name,
              area_id: deviceArea.area_id,
              user_token_id: getRecoil(authState).user_token_id,
              store_id: order.store_id,
              order_id: order.order_id,
              order_seq: order.order_seq,
            };
            const response = await ApiController.chat.createChatRoom(oParams);

            if (response && response.data) {
              const oRes = response.data;
              if (oRes.data) {
                setStoreChatFlag((prev) => ({
                  ...prev,
                  cs_id: oRes.data.cs_id,
                  chat_id: oRes.data.cs_id,
                  area_name: order.store_name,
                }));
                getChats(true, oRes.data.cs_id);

                LogController.event({
                  path: "Chat",
                  params: "storeChat",
                  params2: "고객이 채팅방 생성",
                  index: oRes.data.cs_id,
                });
              }
            }
          }
        } else {
          const oParams = {
            contact_person_type: "ADMIN",
            area_id: deviceArea.area_id,
            user_token_id: getRecoil(authState).user_token_id,
          };
          const response = await ApiController.chat.createChatRoom(oParams);

          if (response && response.data) {
            const oRes = response.data;
            if (oRes.data) {
              setCsChatFlag((prev) => ({
                ...prev,
                cs_id: oRes.data.cs_id,
                area_name: "KNOCKKNOCK",
              }));
              getChats(false, oRes.data.cs_id);

              LogController.event({
                path: "Chat",
                params: "cs",
                params2: "고객이 채팅방 생성",
                index: oRes.data.cs_id,
              });
            }
          }
        }
      }
    } catch (err) {
      console.log("err-->", err);
    }
  };

  // open chat modal
  const openChatModal = () => {
    closeChatConfirm();
    if (visibleChatConfirm.target === "hotel") {
      openConciergeRequestModal();
    } else if (visibleChatConfirm.target === "store") {
      setStoreChatFlag((prev) => ({ ...prev, chat_id: storeChatFlag.cs_id }));
      getChats(true, storeChatFlag.cs_id!);
    } else if (visibleChatConfirm.target === "admin") {
      getChats(false);
    }
  };

  const playMessageAudio = () => {
    if (chatAudio) {
      chatTimer = setTimeout(() => {
        chatAudio.currentTime = 0;
        chatAudio.play();
      }, 1000 * 2);
    }
  };

  // useEffect(() => {
  //   if (csChatFlag.cs_id) {
  //     clearInterval(customerServiceInterval);
  //     customerServiceInterval = setInterval(() => {
  //       resetRecoil(csChatState);
  //     }, 1000 * 60 * 60);
  //   }
  // }, [conciergeFlag, csChatFlag, storeChatFlag]);

  useEffect(() => {
    if (
      chatAudio &&
      visibleChatConfirm.visible &&
      visibleChatConfirm.onEffect
    ) {
      console.log("effect sound play", visibleChatConfirm);

      chatAudio.currentTime = 0;
      chatAudio.play();
      chatAudio.addEventListener("ended", playMessageAudio);
      ExpiredChatTimer = setTimeout(() => {
        console.log("effect sound expired");
        setVisibleChatConfirm({ ...visibleChatConfirm, onEffect: false });
      }, 1000 * 60);
    } else {
      console.log("effect sound end");
      clearTimeout(ExpiredChatTimer);
      clearTimeout(chatTimer);
    }
    return () => {
      chatAudio.removeEventListener("ended", playMessageAudio);
    };
  }, [visibleChatConfirm.visible, visibleChatConfirm.onEffect]);

  // chat socket
  useEffect(() => {
    if (conciergeFlag.concierge_id) {
      console.log("chatting", conciergeFlag);
      if (visibleConciergeRequest) {
        openConciergeRequestModal();
      } else {
        const hotelTitle =
          lang === LANG_KO || lang === LANG_JP
            ? langText.hotel[lang] +
              langText.from[lang] +
              "\n" +
              langText.confirmModal_receive_chat[lang]
            : langText.confirmModal_receive_chat[lang] +
              "\n" +
              langText.from[lang] +
              langText.hotel[lang];
        setVisibleChatConfirm({
          visible: true,
          title: hotelTitle,
          target: "hotel",
          onEffect: true,
        });
      }
    }
  }, [conciergeFlag.date]);

  useEffect(() => {
    if (storeChatFlag.cs_id) {
      if (storeChatFlag.visible) {
        getChats(true);
        if (storeChatFlag.cs_id !== storeChatFlag.chat_id) {
          toast.success(langText.other_chat[lang]);
        }
      } else {
        const storeTitle =
          lang === LANG_KO || lang === LANG_JP
            ? langText.store[lang] +
              langText.from[lang] +
              "\n" +
              langText.confirmModal_receive_chat[lang]
            : langText.confirmModal_receive_chat[lang] +
              "\n" +
              langText.from[lang] +
              langText.store[lang];
        setVisibleChatConfirm({
          visible: true,
          title: storeTitle,
          target: "store",
          onEffect: true,
        });
      }
    }
  }, [storeChatFlag.date]);

  useEffect(() => {
    if (csChatFlag.cs_id) {
      if (csChatFlag.visible) {
        getChats(false);
      } else {
        const adminTitle =
          lang === LANG_KO || lang === LANG_JP
            ? langText.knock_support[lang] +
              langText.from[lang] +
              "\n" +
              langText.confirmModal_receive_chat[lang]
            : langText.confirmModal_receive_chat[lang] +
              "\n" +
              langText.from[lang] +
              langText.knock_support[lang];
        setVisibleChatConfirm({
          visible: true,
          title: adminTitle,
          target: "admin",
          onEffect: true,
        });
      }
    }
  }, [csChatFlag.date]);

  useEffect(() => {
    if (conciergeFlag.isChat && !visibleConciergeRequest) {
      openConciergeRequestModal();
    }
  }, [conciergeFlag.isChat]);

  useEffect(() => {
    console.log("newChatListState", getRecoil(newChatListState));
    setRecoil(newChatListState, (prev) => [
      ...prev.filter((item) => !(item.cs_id === storeChatFlag.chat_id)),
    ]);
  }, [storeChatDetail]);

  useEffect(() => {
    setRecoil(csChatListState, false);
  }, [csChatDetail]);

  useEffect(() => {
    if (csChatFinishedFlag) {
      showToast(langText.finished_chat[lang]);
      resetRecoil(csChatState);
      resetRecoil(csChatFinishedState);
    }
  }, [csChatFinishedFlag]);

  useEffect(() => {
    if (storeChatFinishedFlag) {
      showToast(langText.finished_chat[lang]);
      resetRecoil(storeChatState);
      resetRecoil(storeChatFinishedState);
    }
  }, [storeChatFinishedFlag]);

  useEffect(() => {
    if (!storeChatFlag.visible) {
      setStoreChatFlag((prev) => ({ ...prev, chat_id: storeChatFlag.cs_id }));
    }
  }, [storeChatFlag.visible]);

  return (
    <>
      <ConciergeRequestModal
        isVisible={visibleConciergeRequest}
        setVisible={setVisibleConciergeRequest}
        conciergeRequestData={conciergeRequestData}
        conciergeFlag={conciergeFlag}
      />
      <CustomerServiceChatModal
        isVisible={csChatFlag}
        chatDetail={csChatDetail}
        setChatDetail={setCsChatDetail}
      />
      <StoreChatModal
        isVisible={storeChatFlag}
        chatDetail={storeChatDetail}
        setChatDetail={setStoreChatDetail}
      />
      <SelectChatModal
        isVisible={visibleSelectChat}
        setVisible={setVisibleSelectChat}
        openChatRoom={openChatRoom}
      />
      <ConfirmModal
        isVisible={visibleChatConfirm.visible}
        setVisible={closeChatConfirm}
        title={visibleChatConfirm.title}
        onConfirm={openChatModal}
        confirmText={langText.button_confirm[lang]}
        icon={`${process.env.PUBLIC_URL}/knockknock/svg/ic_letter.svg`}
      />
    </>
  );
};

export default ChatContent;
